const SKIPPED_TAGS = new Set(['STYLE', 'SCRIPT', 'HEAD', 'TITLE', 'NOSCRIPT', 'TEMPLATE']);
const BLOCK_TAGS = new Set([
    'P', 'DIV', 'TABLE', 'TR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL',
    'BLOCKQUOTE', 'PRE', 'SECTION', 'ARTICLE', 'HEADER', 'FOOTER', 'HR', 'CENTER',
]);

/**
 * Plain-text version of an email: drops <style>/<script>, turns links into
 * "text (url)", keeps line structure and leaves {{variables}} untouched.
 */
export function htmlToText(html: string): string {
    if (!html) {
        return '';
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const raw = walk(doc.body);

    return raw
        .split('\n')
        .map(line => line.replace(/[ \t ]+/g, ' ').trim())
        .join('\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
}

function walk(node: Node): string {
    if (node.nodeType === Node.TEXT_NODE) {
        return (node.textContent || '').replace(/\s+/g, ' ');
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return '';
    }

    const element = node as Element;
    const tag = element.tagName;
    if (SKIPPED_TAGS.has(tag)) {
        return '';
    }
    if (tag === 'BR') {
        return '\n';
    }

    const inner = Array.from(element.childNodes).map(walk).join('');

    if (tag === 'A') {
        const href = (element.getAttribute('href') || '').trim();
        const label = inner.trim();
        if (!href || href.startsWith('#')) {
            return inner;
        }
        const url = href.replace(/^mailto:/i, '');
        if (!label) {
            return url;
        }
        return label === url ? label : `${label} (${url})`;
    }
    if (tag === 'LI') {
        return `\n- ${inner.trim()}\n`;
    }
    if (tag === 'TD' || tag === 'TH') {
        return ` ${inner} `;
    }
    if (BLOCK_TAGS.has(tag)) {
        return `\n${inner}\n`;
    }
    return inner;
}
